import styled from '@emotion/styled';

const Container = styled.div<{ isTarget?: boolean }>`
  display: flex;
  gap: 8px;
  padding: 4px;
  border-radius: 4px;
  background-color: ${({ isTarget }) => isTarget && 'var(--dk-bg-subtle, #F9FAFB)'};
  cursor: pointer !important;
  * {
    cursor: pointer !important;
  }
  align-items: center;
`;

const StyledImg = styled.img`
  border-radius: 50%;
  width: 32px;
  height: 32px;
  object-fit: cover;
`;

const StyledCheckbox = styled.input`
  width: 16px;
  accent-color: black;
`;

const StyledLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  width: 100%;
`;

export { StyledImg, StyledCheckbox, StyledLabel, Container };
